'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _dofOverlay = require('../dof-overlay');

var _dofOverlay2 = _interopRequireDefault(_dofOverlay);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofOverlay: _dofOverlay2.default, DofIconfont: _dofIconfont2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    single: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    mainBtnColor: {
      type: String,
      default: ''
    },
    secondBtnColor: {
      type: String,
      default: ''
    },
    // add by lau
    hasInput: {
      type: [Boolean, String],
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputContent: {
      type: String,
      default: ''
    },
    btnGroup: {
      type: Array,
      // default: ['确定','更多','取消']
      default: function _default() {
        return [];
      }
    },
    // modal样式自定义
    modalStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // modal-content样式自定义，适用于修改内部padding等需求
    modalContentStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 底部按钮边框颜色
    modalFooterBorderColor: {
      type: String,
      default: ''
    },
    // subText 颜色
    subTextColor: {
      type: String,
      default: ''
    },
    //是否展示图片
    image: {
      type: String,
      default: ''
    },
    // 图片样式
    imgStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 右上角close图标
    isShowCloseIcon: {
      type: Boolean,
      default: false
    },
    closeIcon: {
      type: String,
      default: ''
    },
    // input弹窗遮挡后偏移量
    inputUpriseOffset: {
      type: [Number, String],
      default: 60
    }
  },
  computed: {
    _modalStyle: function _modalStyle() {
      return _extends({
        borderRadius: this._isColmo ? '0px' : '26px',
        backgroundColor: this._isColmo ? '#232529' : this._isDiablo ? '#1e2326' : '#ffffff'
      }, this.modalStyle);
    },
    _modalFooterBorderColor: function _modalFooterBorderColor() {
      if (this.modalFooterBorderColor) return this.modalFooterBorderColor;
      return this._isColmo ? 'rgba(255,255,255,0.1)' : this._isDiablo ? '#303538' : '#dddddd';
    },
    _secondBtnColor: function _secondBtnColor() {
      if (this.secondBtnColor) return this.secondBtnColor;
      return this._isColmo ? 'rgba(255,255,255,0.40)' : this._isDiablo ? '#0490d3' : '#00A4F2';
    },
    _subTextColor: function _subTextColor() {
      if (this.subTextColor) return this.subTextColor;
      return this._isColmo ? 'rgba(255,255,255,0.60)' : this._isDiablo ? '#cfcfd0' : '#111111';
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    var env = weex.config.env;
    this.pageHeight = env.deviceHeight / env.deviceWidth * 750;
  },

  methods: {
    cancelClicked: function cancelClicked() {
      this.$emit('dofModalCancelBtnClicked', {
        type: 'cancel',
        content: this.inputContent
      });
    },
    primaryClicked: function primaryClicked() {
      this.$emit('dofModalConfirmBtnClicked', {
        type: 'confirm',
        content: this.inputContent
      });
    },
    layoutClick: function layoutClick() {
      this.$emit('close', {});
    },
    closeIconClick: function closeIconClick() {
      this.$emit('closeIconClicked', {});
    },

    // add by lau
    moreBtnClicked: function moreBtnClicked(index, text) {
      this.$emit('btnItemClicked', {
        index: index,
        text: text
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-modal/index.vue
// module id = 355
// module chunks = 0 1